<nz-spin nzTip='Logging you in...' [nzSpinning]="loading" [nzSize]="'large'">
  <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="onSubmit()">
    <nz-form-item [ngClass]="{'has-error':f.email.dirty && f.email.errors, 'has-value':f.email.value}">
      <nz-form-label [nzRequired]="true">Email address</nz-form-label>
      <nz-form-control [nzErrorTip]="emailValidationsTpl">
        <ng-template #emailValidationsTpl>
          <ng-container *ngIf="f.email?.dirty &&  f.email.errors && f.email.errors.required">
            Email is required
          </ng-container>
          <ng-container *ngIf="f.email?.dirty &&  f.email.errors && f.email.errors.email">
            Email is not valid
          </ng-container>
        </ng-template>

        <nz-input-group [nzPrefix]="prefixUser" nzSize="large">
          <input type="text" nz-input formControlName="email" name="email" id="email" placeholder="Enter your email">
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item
      [ngClass]="{'has-error':f.password.dirty && f.password.errors, 'has-value':f.password.value, 'login-password':true}">
      <nz-form-label [nzRequired]="true">Password</nz-form-label>
      <nz-form-control
        [nzErrorTip]="f.password?.dirty && f.password.errors && f.password.errors.required ? 'Password is required' : ''">
        <nz-input-group [nzPrefix]="prefixLock" nzSize="large" [nzSuffix]="suffixTemplate">
          <input [type]="passwordVisible ? 'text' : 'password'" nz-input formControlName="password" name="password"
                 id="password" placeholder="Enter your password">
        </nz-input-group>
        <ng-template #suffixTemplate>
          <em nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
             (click)="passwordVisible = !passwordVisible"></em>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <app-captcha *ngIf="!disCap" [form]="form"
                 (resolved)="captchaResolved($event)">
    </app-captcha>

    <nz-form-item class="margin-bottom-regular">
      <nz-form-control>
        <button [nzLoading]="loading" nz-button nzSize="large" nzType="primary" nzBlock id="submit"
                class="primary-button"
                [disabled]="!disCap && (
                  form.invalid ||
                  (form.dirty && form.errors) ||
                  (env.captcha && !(f.captcha?.value && isCaptchaVerified)) ||
                  (env.captcha && f.captcha?.errors?.required)
                )"
        >
          Sign In
        </button>
      </nz-form-control>
    </nz-form-item>

    <div class="create-account"><span>New to Nexxen CTRL?</span>
      <a class="underlined-link-button margin-left-1 semibold-font font-size-large
        font-icon-color-primary-black-important font-icon-hover-color-shade-slate-blue-important"
         routerLink="/signup"><span>Create an Account</span>
      </a>
    </div>
  </form>
  <ng-template #prefixUser><em nz-icon nzType="user"></em></ng-template>
  <ng-template #prefixLock><em nz-icon nzType="lock"></em></ng-template>
</nz-spin>
